import React, { useState } from 'react';

import { ChevronLeftIcon } from '@/shared/assets/icons/chevron-left-icon';
import { ChevronRightIcon } from '@/shared/assets/icons/chevron-right-icon';
import { NavigationSection } from '@/shared/features/sidebar/components/navigation-section/navigation-section';
import {
  BottomContent,
  CustomDrawer,
  ExpandCollapseButton,
  LogoContainer,
  SectionsContainer,
  TopContent,
} from '@/shared/features/sidebar/sidebar.styled';
import { TSidebarProps } from '@/shared/features/sidebar/sidebar.types';
import { ConditionalLogo } from '@/shared/features/theme-switcher/components/conditional-logo/conditional-logo';

export const Sidebar: React.FC<TSidebarProps> = ({
  sections,
  bottomContent,
}) => {
  const [open, setOpen] = useState<boolean>(false);

  return (
    <>
      <ExpandCollapseButton
        onClick={() => setOpen((prev) => !prev)}
        $open={open}
      >
        {open ? <ChevronLeftIcon /> : <ChevronRightIcon />}
      </ExpandCollapseButton>
      <CustomDrawer variant="permanent" open={open}>
        <TopContent>
          <LogoContainer $open={open}>
            <ConditionalLogo />
          </LogoContainer>
          <SectionsContainer>
            {sections?.map((section, index) => (
              <NavigationSection
                key={`${index}__${section.name}`}
                open={open}
                {...section}
              />
            ))}
          </SectionsContainer>
        </TopContent>
        {bottomContent && (
          <BottomContent>{bottomContent?.(open)}</BottomContent>
        )}
      </CustomDrawer>
    </>
  );
};
